import { render } from "./domiciliation-salaire-valid.vue?vue&type=template&id=006265be"
import script from "./domiciliation-salaire-valid.vue?vue&type=script&lang=js"
export * from "./domiciliation-salaire-valid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__